import { HostAPIBase } from './HostAPIBase';
export class HostAPIEditorX extends HostAPIBase {
    constructor() {
        super(...arguments);
        this.breakpoints = {
            get: (compRef) => {
                return this.platformApiMethods.editor.breakpoints.get(compRef);
            },
        };
    }
}
//# sourceMappingURL=HostAPIEditorX.js.map